const SpacingForHeader = () => {
  return <div style={{ height: "45px" }}></div>
}
export default SpacingForHeader